<app-home [avatar]="false"
          [darkTheme]="true"
          [menu]="menu"
          [miniSidenav]="true"
          [titre]="title"
          class="mat-typography" version="(3.5)">
</app-home>
<span *ngIf="showLoader" class="loading"></span>
